import { AnyValue } from "../../_webui/layout/models"
import { Translate } from "../../constant/Translate"

const { MESSAGE_I0023 } = Translate

export const getScheduleDeleted = (
  isTravelerDeleted: boolean,
  value: AnyValue,
) => (isTravelerDeleted ? MESSAGE_I0023 : value)
